import React from 'react';
import { XMarkIcon, UserCircleIcon } from '@heroicons/react/24/outline';

const Drawer = ({
  open,
  onClose,
  title,
  subtitle,
  avatar,
  children,
}) => {
  return (
    <div className={`fixed inset-0 z-50 flex ${open ? '' : 'pointer-events-none'}`}>
      {/* Overlay */}
      <div
        className={`fixed inset-0 bg-black bg-opacity-30 transition-opacity duration-300 ${open ? 'opacity-100' : 'opacity-0'}`}
        onClick={onClose}
        aria-label="Close drawer"
      />
      {/* Drawer Panel */}
      <div
        className={`ml-auto h-full bg-white shadow-none max-w-md sm:max-w-lg transition-transform duration-300 ease-in-out ${open ? 'translate-x-0' : 'translate-x-full'} flex flex-col relative`}
        style={{ minWidth: '320px' }}
        role="dialog"
        aria-modal="true"
      >
        {/* Header Bar */}
        <div className="flex items-center justify-between px-4 py-3 border-b">
          <div className="flex items-center min-w-0">
            <div className="h-10 w-10 rounded-full bg-gray-100 flex items-center justify-center overflow-hidden flex-shrink-0">
              {avatar ? (
                typeof avatar === 'string' ? (
                  <img src={avatar} alt="Avatar" className="h-full w-full object-cover" />
                ) : (
                  avatar
                )
              ) : (
                <UserCircleIcon className="h-8 w-8 text-gray-400" />
              )}
            </div>
            <div className="min-w-0 ml-3">
              <h1 className="text-lg font-semibold text-gray-900 truncate">{title}</h1>
              {subtitle && <p className="text-gray-400 text-sm truncate">{subtitle}</p>}
            </div>
          </div>
          <button
            className="ml-4 p-2 rounded-full bg-white border border-gray-200 hover:bg-blue-50 focus:outline-none focus:ring-2 focus:ring-blue-400"
            onClick={onClose}
            aria-label="Close drawer"
            tabIndex={0}
          >
            <XMarkIcon className="h-6 w-6 text-gray-700" />
          </button>
        </div>
        {/* Drawer Content */}
        <div className="flex-1 overflow-y-auto px-2 sm:px-4">
          {children}
        </div>
      </div>
    </div>
  );
};

export default Drawer;